"use strict";
// Why do we have two sets of column labels?
// The regular labels are used for validation and parsing and should rarely change.
// The augmented labels are used to provide additional information about the column to the user.
// This additional information is ignored during validation and parsing.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = void 0;
exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = {
    rdCategory: 'Expense Category',
    name: 'Name',
    amount: 'Amount',
    state: 'State',
    country: 'Country',
    account: 'Account',
    department: 'Department',
    costCenter: 'Cost Center',
    entity: 'Entity',
};
// WARNING: Don't use line breaks (\n) in the headers, because they won't display consistently in
// spreadsheet apps with unpredictable wrapping that can confuse users.
exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
    rdCategory: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.rdCategory +
        ' (Required) (Enter ONE category for each expense: Contractors, Cloud, Supplies)',
    name: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.name + ' (Required)',
    amount: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.amount + ' (Required)',
    state: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.state + ' (Required if Country is US) (Use the two-letter code)',
    country: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.country + ' (Recommended)',
    account: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.account + ' (Recommended)',
    department: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.department + ' (Recommended)',
    costCenter: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.costCenter + ' (Recommended)',
    entity: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.entity + ' (Required when multiple entities perform R&D)',
};
exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = {
    fullName: 'Name',
    title: 'Job Title',
    department: 'Department',
    pid: 'Employee ID',
    managerPid: 'Manager ID',
    email: 'Work Email',
    employeeWages: 'W-2 Box 1 Wages',
    contractorWages: 'Contractor Wages',
    state: 'State',
    country: 'Country',
    hireDate: 'Hire Date',
    terminationDate: 'Termination Date',
    costCenter: 'Cost Center',
    entity: 'Entity',
};
// WARNING: Don't use line breaks (\n) in the headers, because they won't display consistently in
// spreadsheet apps with unpredictable wrapping that can confuse users.
exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
    fullName: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.fullName + ' (Required)',
    title: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.title + ' (Required)',
    department: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.department + ' (Recommended)',
    pid: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.pid + ' (Recommended)',
    managerPid: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.managerPid + ' (Recommended)',
    email: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.email + ' (Recommended)',
    employeeWages: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.employeeWages +
        ' (Required) (For international employees, enter the equivalent)',
    contractorWages: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.contractorWages +
        ' (Required for Contractors) (For non-W2 contractors, enter the amount in this column)',
    state: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.state + ' (Required if Country is US) (Use the two-letter code)',
    country: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.country + ' (Required)',
    hireDate: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.hireDate + ' (Recommended) (Format: MM/DD/YYYY)',
    terminationDate: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.terminationDate + ' (Recommended) (Format: MM/DD/YYYY)',
    costCenter: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.costCenter + ' (Recommended)',
    entity: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.entity + ' (Required when multiple entities perform R&D)',
};
exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = {
    fullName: 'Name',
    title: 'Job Title',
    department: 'Department',
    email: 'Work Email',
    salaryCompensationDollars: 'Salary/Benefits Cost',
    stockCompensationDollars: 'Stock Based Comp Cost',
    country: 'Country',
    pid: 'Employee ID',
    managerPid: 'Manager ID',
    hireDate: 'Hire Date',
    terminationDate: 'Termination Date',
    costCenter: 'Cost Center',
    entity: 'Entity',
};
// WARNING: Don't use line breaks (\n) in the headers, because they won't display consistently in
// spreadsheet apps with unpredictable wrapping that can confuse users.
exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
    fullName: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.fullName + ' (Required)',
    title: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.title + ' (Required)',
    department: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.department + ' (Recommended)',
    email: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.email + ' (Required)',
    salaryCompensationDollars: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.salaryCompensationDollars + ' (Required)',
    stockCompensationDollars: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.stockCompensationDollars + ' (Recommended)',
    country: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.country + ' (Required)',
    pid: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.pid + ' (Recommended)',
    managerPid: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.managerPid + ' (Recommended)',
    hireDate: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.hireDate + ' (Recommended) (Format: MM/DD/YYYY)',
    terminationDate: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.terminationDate + ' (Recommended) (Format: MM/DD/YYYY)',
    costCenter: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.costCenter + ' (Recommended)',
    entity: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.entity + ' (Required when multiple entities perform R&D)',
};
